'use client';

import { useEffect, useState } from 'react';

import { fetchAuthPropsOnClient } from '../client';

import type { AuthProps } from '../types/auth';

export type ClientAuthProps = AuthProps & {
  ready: boolean;
};

/**
 * Returns the client variant of {@link AuthProps} of the current user.
 * The client variant of the auth props has one additional property: `ready`.
 *
 * The value of `ready` tells you if the async logic of fetching the current user's session is completed.
 * Make sure to rerun any user based logic once the value of `ready` changes.
 */
export const useAuthProps = (): ClientAuthProps => {
  const [authProps, setAuthProps] = useState<ClientAuthProps>({
    ready: false,
    authenticated: false,
    idToken: '',
    accessToken: '',
    impersonated: false,
  });

  useEffect(() => {
    const exec = async () => {
      setAuthProps({
        ready: true,
        ...(await fetchAuthPropsOnClient()),
      });
    };

    exec();
  }, []);

  return authProps;
};
